export interface Site {
  id: string; // ari:cloud:<product>::site/<site-id>
  baseUrl: string;
  siteName: string;
}

export interface SiteMetadata {
  siteId: string;
  siteName: string;
  orgId: string;
  isNounsAvailable: boolean;
  isRovoEnabled: boolean;
  productDataRegions?: Record<string, string[]>;
  productEdition?: Record<string, string>;
}

export type Resources = {
  resources: Site[];
  siteMetadata: SiteMetadata[];
};

export type Me = {
  account_id?: string;
  email?: string;
  name?: string;
  picture?: string;
  account_status?: string;
  characteristics?: { not_mentionable?: boolean };
  last_updated?: string;
  nickname?: string;
  zoneinfo?: string;
  locale?: string;
  extended_profile?: {
    job_title?: string;
    department?: string;
    location?: string;
  };
  account_type?: string;
  email_verified?: boolean;
};

export const isUserAccount = (data: Partial<UserAccount>): data is UserAccount => {
  return Boolean(data.accountId && data.email && data.name && data.nickname && data.picture);
};

export interface UserAccount {
  accountId: string;
  email: string;
  name: string;
  nickname: string;
  picture: string;
}

export interface AtlassianSite {
  cloudId: string;
  siteName: string;
  baseUrl: string;
  orgId: string;
}

export interface AssistFeatures {
  account_id: string;
  activation_id: string;
  ai_enabled_on_site: boolean;
  assistance_feature_enabled: boolean;
  cloud_id: string;
  debug_enabled: boolean;
  env: string;
  env_type: string;
  model: string;
  product: string;
}

export type ChatConfig = {
  chatBaseUrl: string;
};

export type OrgAccess = { permitted: boolean };

export type PermissionResponse = {
  permitted: boolean;
};

export type RovoEntitlementResponse = {
  isRovoEnabled: boolean;
  isRovoLLMEnabled: boolean;
  reason: string | null;
};

export interface SitesWithRovoEnabledResult {
  results: AtlassianSite[];
  metadata: {
    sitesFound: number;
    sitesWithRovoEnabled: number;
    entitlementErrorCount?: number;
    expectedSitesWithRovoEnabled?: number;
    rovoEnabledSitesMap: Record<string, { isRovoEnabled: boolean; orgId: string }>;
  };
}

// Define error types as enum for runtime values
export enum SettingsErrorType {
  NETWORK_ERROR = 1000,
  VALIDATION_ERROR = 1001,
  SERVER_ERROR = 1002,
  UNKNOWN_ERROR = 1003,
}

export type CompanyThemingSettingsData = {
  fontColorLight: string | null;
  fontColorDark: string | null;
  navbarColorLight: string | null;
  navbarColorDark: string | null;
};
